<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="商品编码/名称" prop="skuCode">
            <el-input v-model.trim="searchForm.skuCode" placeholder="请输入" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品编码/名称" prop="productCode">
            <el-input v-model.trim="searchForm.productCode" placeholder="请输入" @keyup.enter.native="onSearch" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
      <el-table-column v-for="item in columnData" :prop="item.fieldName" :label="item.fieldDesc" min-width="100" show-overflow-tooltip :key="item.fieldName">
          <template slot-scope="{ row }">
              {{ row[item.fieldName] }}
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import imgShow from '@/views/components/imgShow';
import moment from 'moment';
export default {
  name: 'ProductPriceList',
  mixins: [tableMixin, pagePathMixin],
  components: { imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      imgList: [],
      searchForm: {
        skuCode: '',
        productCode: '',
      },
      rowData: {},
      exportData: {},
      importCfg: {},
    };
  },
  computed: {
    listNo() {
      return this.$route.query.listNo
    }
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          listNo: this.listNo,
          ...this.searchForm
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productListPriceList({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.columnData = [...res.data.titleList];
            const actualExecPriceIndex = this.columnData.findIndex((item) => item.fieldName === 'dailyRetailPrice');
            if (!this.columnData.find((item) => item.fieldName === 'actualExecPrice')) {
              const actualExecPrice = {
                fieldName: 'actualExecPrice',
                fieldDesc: '实际执行价',
              };
              if (actualExecPriceIndex > -1) {
                this.columnData.splice(actualExecPriceIndex + 1, 0, actualExecPrice);
              } else {
                this.columnData.push(actualExecPrice);
              }
            }
            this.tableData = res.data.pageInfo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      (this.searchForm = {
        skuCode: '',
        productCode: '',
      }),
        (this.tableData.pageNum = 1);
      this.onSearch();
    },

    handleExport() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.searchFormData.pageSize = 9999999
      this.$q.newProduct
        .priceListExport({
          data: this.searchFormData,
          options: { responseType: 'blob' },
        })
        .then((res) => {
          let fileName = '产品价格清单' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.blobDownload(res, `${fileName}.xlsx`);
          loading.close();
        });
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
</style>
